import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initSentry } from '@rd-lib/sentry/sentry-init';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import './component-map';
import { environment } from './environments/environment';

const { shortBrandName, env } = environment;

if (environment.production) {
  enableProdMode();
}

initSentry(shortBrandName, env);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err: Error) => {
    console.error('App Bootstrap error', err);
    Sentry.captureException(err);
  });
